import { render, staticRenderFns } from "./HseTypeIndex.vue?vue&type=template&id=38a909b4"
import script from "./HseTypeIndex.vue?vue&type=script&lang=js"
export * from "./HseTypeIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports